<template>
  <v-container grid-list-md v-if="this.$store.getters.programsFetched">

    <div v-if="this.referrers">
      <v-layout row>
        <v-flex xs4>
          <h1>Referrers (Manufacturers)</h1>
        </v-flex>
        <v-spacer/>
        <v-flex xs3>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="referrers"
            disable-initial-sort
            class="elevation-1"
          >
            <template v-slot:items="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.sortToBottom }}</td>
              <td>{{ props.item.hasDealerNumber }}</td>

              <td class="text-xs-right">

                <v-menu offset-y open-on-hover>
                  <template slot="activator">
                    <v-btn small fab>
                      <v-icon>list</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile>
                      <v-btn flat small round @click="editRef(props.item)">
                        Edit
                      </v-btn>
                    </v-list-tile>

                    <v-list-tile>
                      <v-btn flat small round @click="deleteReferrer(props.item)">
                        Delete
                      </v-btn>
                    </v-list-tile>
                  </v-list>
                </v-menu>

              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" type="info" icon="warning">
                Your search for "{{ search }}" found no results.
              </v-alert>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </div>

    <div v-if="!this.referrers">
      <v-layout row>
        <v-flex>
          <div class="text-xs-center">
            <h3>
              This program does not have referrers set up
            </h3>
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-dialog
      v-model="dialog"
      @keydown.esc="dialog = false"
      persistent
      max-width="500px"
    >
      <v-btn
        v-show="this.referrers"
        slot="activator"
        class="btn-primary"
      >
        <img src="static/icons/add_white.png" width="24" />
        {{ $t('message.add') }}
      </v-btn>
      <v-form
        ref="referrerForm"
        v-model="valid"
        @keydown="errors.clear($event.target.name)"
      >
        <v-card>
          <v-flex
            xs24 sm12 v-show="loading"
            class="grey" style="opacity:50%;position: absolute;width: 100%;height: 100%;"
          >
            <v-progress-circular
              style="width: 100%;"
              :size="70" :width="8"
              indeterminate color="primary"
            ></v-progress-circular>
          </v-flex>
          <v-card-title>
              <span v-if="referrerIndex == -1" class="headline">
                New Referrer
              </span>
              <span v-else class="headline">
                Update Referrer
              </span>
          </v-card-title>
          <v-card-text>
            <v-container grid-list-md class="no-top-padding">
              <v-layout row wrap>
                <v-flex xs12>
                  <v-text-field
                    v-model="referrer.name"
                    label="Name"
                    validate-on-blur required
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <input type="checkbox" v-model="referrer.sortToBottom">
                  <label>Sort To Bottom</label>
                </v-flex>

                <v-flex xs12>
                  <input type="checkbox" v-model="referrer.hasDealerNumber">
                  <label>Has Dealer Number</label>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat class="btn-secondary" @click.native="close">{{
              $t('message.cancel')
              }}</v-btn>
            <v-btn flat class="btn-primary"
              v-show="this.referrerIndex == -1"
              @click="addReferrer"
              :disabled="saveDisabled"
            >
              {{ $t('message.add') }}
            </v-btn>

            <v-btn
              flat class="btn-primary"
              v-show="this.referrerIndex != -1"
              @click="updateReferrer" :disabled="saveDisabled"
            >
              {{ $t('message.save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

  </v-container>
</template>

<script>
  import { axiosAuthInstance } from '../../main.js'
  import EmptyList from '../util/EmptyList'

  export default {
    data: () => ({
      search: '',
      referrers: [],
      referrer: {},
      referrerIndex: -1,
      saveDisabled: false,
      valid: true,
      dialog: false,
      loading: false,
      headers: [
        {text: 'Name',  align: 'left', value: 'name'},
        {text: 'Sort To Bottom',  align: 'left', value: 'sortToBottom'},
        {text: 'Has Dealer Number',  align: 'left', value: 'hasDealerNumber'},
        {text: '', value: ''}
      ]
    }),
    methods: {
      deleteReferrer(inReferrer) {
        this.saveDisabled = true
        this.loading = true

        confirm('Are you sure you want to delete this referrer?') &&
        axiosAuthInstance
          .delete('api/v1/admin/referrer/'+this.$store.getters.getDomain, { data: inReferrer})
          .then(response => {
            this.close()
            this.notifyInfo('Referrer deleted')
            if (response.data && response.data.referrers)
            this.$store.getters.getProgram.referrers = response.data.referrers
            this.refreshReferrers()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error deleting the referrer'
            )
          })
          .then(() => {
            this.loading = false
            this.saveDisabled = false
            this.dialog = false
          })
      },
      updateReferrer() {
        this.saveDisabled = true
        this.loading = true
        axiosAuthInstance
          .post('api/v1/admin/referrer/update/'+this.$store.getters.getDomain, this.referrer)
          .then(response => {
            this.close()
            this.notifyInfo('Referrer updated')
            this.$store.getters.getProgram.referrers = response.data.referrers
            this.refreshReferrers()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error updating the referrer'
            )
          })
          .then(() => {
            this.resetState()
          })
      },
      addReferrer() {
        this.saveDisabled = true
        this.loading = true
        axiosAuthInstance
          .post('api/v1/admin/referrer/create/'+this.$store.getters.getDomain, this.referrer)
          .then(response => {
            this.close()
            this.notifyInfo('Referrer added')
            this.$store.getters.getProgram.referrers = response.data.referrers
            this.refreshReferrers()
          })
          .catch(error => {
            this.notifyAxiosError(
              error,
              'There was an error adding the referrer'
            )
          })
          .then(() => {
            this.resetState()
          })
      },
      editRef(inRef) {
        this.referrerIndex = this.referrers.indexOf(inRef)
        this.referrer = Object.assign({}, inRef)
        this.dialog = true
      },
      resetState() {
        this.$refs.referrerForm.reset()
        this.referrerIndex = -1
        this.referrer = {}
        this.saveDisabled = false
        this.loading = false
      },
      close() {
        this.dialog = false
      },
      refreshReferrers() {
        this.referrers = this.$store.getters.getProgram.referrers
      }
    },
    components: {
      'empty-list': EmptyList
    },
    mounted() {
      this.resetState()
      this.refreshReferrers()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/admin/Referrers.vue